(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductLotDeleteController',ProductLotDeleteController);

    ProductLotDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductLot'];

    function ProductLotDeleteController($uibModalInstance, entity, ProductLot) {
        var vm = this;
        vm.productLot = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProductLot.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
